import { Mail } from 'lucide-react';
import { useEffect, useId, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonLink, Dialog, Input } from '@artosera/ui';
import { dateSalle } from './salleUi.js';
import styles from './ViewingRoomDetailPage.module.css';

export function LienSalleDialog({
  url,
  expireLe,
  contactEmail,
  titre,
  onFermer,
}: {
  url: string;
  expireLe: string;
  contactEmail: string | null;
  titre: string;
  onFermer: () => void;
}) {
  const { t, i18n } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);
  const id = useId();
  const [copie, setCopie] = useState(false);
  const [erreur, setErreur] = useState(false);
  useEffect(() => {
    ref.current?.focus();
    ref.current?.select();
  }, []);
  const corps = `${t('regie:viewingRooms.lien.bonjour')}\n\n${url}\n\n${t('regie:viewingRooms.lien.valable', { date: dateSalle(expireLe, i18n.language) })}`;
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onFermer();
      }}
      title={t('regie:viewingRooms.lien.titre')}
      description={t('regie:viewingRooms.lien.unique')}
      closeLabel={t('regie:viewingRooms.fermer')}
    >
      <div className={styles.formulaire} data-ui="viewing-room-link-dialog">
        <label className={styles.champ} htmlFor={id}>
          {t('regie:viewingRooms.lien.titre')}
          <Input id={id} ref={ref} readOnly value={url} onFocus={(e) => e.currentTarget.select()} />
        </label>
        <p>{t('regie:viewingRooms.lien.valable', { date: dateSalle(expireLe, i18n.language) })}</p>
        <div className={styles.actions}>
          <Button
            onClick={() => {
              void Promise.resolve()
                .then(() => navigator.clipboard.writeText(url))
                .then(() => {
                  setCopie(true);
                  setErreur(false);
                })
                .catch(() => setErreur(true));
            }}
          >
            {t('regie:viewingRooms.lien.copier')}
          </Button>
          <ButtonLink
            variant="secondary"
            href={`mailto:${encodeURIComponent(contactEmail ?? '')}?subject=${encodeURIComponent(titre)}&body=${encodeURIComponent(corps)}`}
          >
            <Mail size={16} strokeWidth={1.5} aria-hidden />
            {t('regie:viewingRooms.lien.ecrire')}
          </ButtonLink>
        </div>
        {copie && <p role="status">{t('regie:viewingRooms.lien.copie')}</p>}
        {erreur && <p role="alert">{t('regie:viewingRooms.lien.erreurCopie')}</p>}
      </div>
    </Dialog>
  );
}
